<template>
    <div>
        <create-task-headline
            title="Skapa ny kryssruta"
            help-text="En kryssruta är en enkel uppgift som kryssas för när den är genomförd"
        />

        <form @submit.prevent="create">
            <text-input
                v-model="body"
                label="Uppgift"
                name="body"
                :autofocus="true"
            />

            <add-dependency
                v-model="task_template_parent_id"
                :task-list-template="taskListTemplate"
            />

            <div class="button-group">
                <button
                    type="button"
                    class="btn btn-md is-ghost"
                    @click="$emit('cancel')"
                >
                    Avbryt
                </button>

                <checkbox-input
                    v-model="createMoreOfThisType"
                    class="my-md lg:my-0"
                    value="1"
                >
                    Skapa fler av denna typ
                </checkbox-input>

                <button type="submit" class="btn btn-md is-primary">
                    Skapa
                </button>
            </div>
        </form>
    </div>
</template>
<script>
    import BaseCreate from './BaseCreate';
    import CreateTaskHeadline from './Headline';
    import AddDependency from './AddDependency';

    export default {
        components: {
            CreateTaskHeadline,
            AddDependency,
        },
        extends: BaseCreate,
        props: {
            taskListTemplate: {
                required: true,
                type: Object,
            },
        },
        data() {
            return {
                body: '',
                type: 'checkbox',
            };
        },
    };
</script>